
import { Vue } from "vue-class-component";

export default class CustomerService extends Vue {}
